/* Move server rendered forms into comparison columns. Existing storefront cart
   handling owns submission, inventory errors, confirmation and drawer refresh. */
(()=>{'use strict';
function init(){
 for(const source of document.querySelectorAll('[data-comparison-shopping]')){
  if(source.dataset.placed)continue;
  const page=[...document.querySelectorAll('[data-comparison-page]')].find(p=>p.dataset.comparisonPage===source.dataset.comparisonShopping);
  if(!page)continue;
  const targets=page.querySelectorAll('.cmp-offer').length?page.querySelectorAll('.cmp-offer'):page.querySelectorAll('.family-cards article');
  const purchases=[...source.querySelectorAll('[data-comparison-purchase]')];
  // A partial/mismatched binding stays as a visible buying section below the page.
  if(purchases.length!==targets.length)continue;
  for(const purchase of purchases){
   const target=targets[Number(purchase.dataset.comparisonPurchase)];if(!target)continue;
   for(const old of target.querySelectorAll(':scope > .family-product-link,:scope > .cmp-product-link,:scope > p')){
    if(target.matches('.cmp-offer')||old.matches('a'))old.remove();
   }
   purchase.classList.add('is-placed');target.append(purchase);
  }
  source.dataset.placed='true';source.hidden=true;
 }
}
function counts(items){
 for(const purchase of document.querySelectorAll('[data-comparison-purchase]')){
  const count=items.filter(i=>String(i.variant_id||i.id)===purchase.dataset.variantId).reduce((n,i)=>n+i.quantity,0);
  const hint=purchase.querySelector('[data-comparison-in-cart]');hint.hidden=!count;hint.textContent=hint.dataset.label+': '+count;
 }
}
document.addEventListener('osn:cart-items',event=>{if(Array.isArray(event.detail?.items))counts(event.detail.items);});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
